var _rect, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPmeIot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 250",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2C3E50",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#3498DB",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "techGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#00FFA3",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#00C9FF",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 250,
    fill: "url(#bgGradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    stroke: "#FFFFFF",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 40,
    r: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 60,
    r: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 80,
    r: 3,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 20,
    x2: 60,
    y2: 40
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 40,
    x2: 30,
    y2: 60
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 60,
    x2: 50,
    y2: 80
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40, 125)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fontFamily: "Arial Black, sans-serif",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 0,
    fontSize: 50,
    letterSpacing: 2
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    dy: 0
  }, "PME"), /*#__PURE__*/React.createElement("tspan", {
    x: 140,
    dy: 0
  }, "-"), /*#__PURE__*/React.createElement("tspan", {
    x: 180,
    dy: 0
  }, "IoT"))), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 15,
    width: 320,
    height: 3,
    fill: "url(#techGradient)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF",
    fontFamily: "Arial Black, sans-serif",
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 50,
    fontSize: 15,
    letterSpacing: 3
  }, "\n        IA G\xE9n\xE9rative\n      "), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 70,
    fontSize: 15,
    letterSpacing: 3
  }, "\n        Parcours de donn\xE9es client\n      ")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,0 L60,17.32 L60,51.96 L30,69.28 L0,51.96 L0,17.32 Z",
    fill: "none",
    stroke: "url(#techGradient)",
    strokeWidth: 2,
    opacity: 0.3,
    transform: "scale(0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0 L60,17.32 L60,51.96 L30,69.28 L0,51.96 L0,17.32 Z",
    fill: "none",
    stroke: "url(#techGradient)",
    strokeWidth: 2,
    opacity: 0.3,
    transform: "translate(20, -10) scale(0.3)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(320, 50)",
    fill: "#FFFFFF",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 0,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 30,
    y2: 10,
    stroke: "#FFFFFF",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 10,
    x2: 20,
    y2: 0,
    stroke: "#FFFFFF",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmeIot);
export default __webpack_public_path__ + "static/media/pme-iot.fb1f40307072ff791e8f551bd833e2cb.svg";
export { ForwardRef as ReactComponent };